export interface ContactPhone {
  dialCode: number;
  iso2: string;
  country: string;
  number: string;
}

export interface ContactDetails {
  email: string;
  phone: ContactPhone;
}

export const DEFAULT_CONTACT_PHONE: ContactPhone = {
  dialCode: 0,
  iso2: '',
  country: '',
  number: ''
};
